'use client'

import { RefObject } from 'react'

import { useOnClickOutside } from '../../../../hooks/useOutsideClick'

const SELECT_MENU_SELECTOR = '.select-input__menu, .select-input__menu-portal'

/**
 * Closes the modal on clicks outside the modal layer, but ignores react-select dropdown menus
 * which may render outside the dialog via fixed positioning or a menu portal.
 */
export function useModalClickOutside(
    modalLayerRef: RefObject<HTMLElement | null>,
    onOutsideClick: () => void,
): void {
    useOnClickOutside(modalLayerRef, (event) => {
        const target = event.target as Element

        if (target.closest(SELECT_MENU_SELECTOR)) {
            return
        }

        onOutsideClick()
    })
}
